import { z, ZodRawShape } from 'zod/v3';
import { objectWithMeta } from '../objectMeta';

export const zObjectWithMeta = <S extends ZodRawShape, M extends ZodRawShape>(
  schema: S,
  meta: M,
) => z.object(objectWithMeta(schema, z.object(meta).readonly().optional()));
